import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'
import {  AuthorCourses,
AuthorSubcourse,
AuthorSection,
AuthorLessons,
AuthorItem,
AuthorItems,
AuthorPassages,
AuthorPassage,
AuthorInteractionBank,
AuthorDecks,
AuthorDeck,
AuthorCards,
AuthorPreview,
AuthorCourseContents
 } from '../components/Users/Authors'

class AuthorContainer extends Component {

  render() {
    const {props} = this;
    return (
      <div>
        <Switch>
          <Route path='/author/courses/' render={(newProps) => <AuthorCourses {...{ ...props, ...newProps }} />}/>
          <Route path='/author/course/:courseId' render={(newProps) => <AuthorCourseContents {...{ ...props, ...newProps }} />}/>
          <Route path='/author/subcourse/:subcourseId' render={(newProps) => <AuthorSubcourse {...{ ...props, ...newProps }} />}/>
          <Route path='/author/section/:sectionId' render={(newProps) => <AuthorSection {...{ ...props, ...newProps }} />}/>   
          <Route path='/author/lesson/:lessonId' render={(newProps) => <AuthorLessons {...{ ...props, ...newProps }} />}/>
          <Route path='/author/item/:itemId' render={(newProps) => <AuthorItem {...{ ...props, ...newProps }} />}/>      
          <Route path='/author/items' render={(newProps) => <AuthorItems {...{ ...props, ...newProps }} />}/>
          <Route path='/author/passages' render={(newProps) => <AuthorPassages {...{ ...props, ...newProps }} />}/> 
          <Route path='/author/passage/:passageId' render={(newProps) => <AuthorPassage {...{ ...props, ...newProps }} />}/>
          <Route path='/author/interaction-bank/:interactionBankId' render={(newProps) => <AuthorInteractionBank {...{ ...props, ...newProps }} />}/>           
          <Route path='/author/decks' render={(newProps) => <AuthorDecks {...{ ...props, ...newProps }} />}/>           
          <Route path='/author/deck/:deckId' render={(newProps) => <AuthorDeck {...{ ...props, ...newProps }} />}/>           
          <Route path='/author/cards' render={(newProps) => <AuthorCards {...{ ...props, ...newProps }} />}/>           
          <Route path='/author/preview/:recordType/:recordId' render={(newProps) => <AuthorPreview {...{ ...props, ...newProps }} />}/>           
         </Switch>
      </div>
    )
  }
}

export default AuthorContainer;


// WEBPACK FOOTER //
// ./src/containers/AuthorContainer.js